module.exports = __webpack_public_path__ + "fonts/Gilroy-ExtraBoldItalic.04a0adfb.eot";